module.exports = __webpack_public_path__ + "static/img/bgImage4-content.3cc1261.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/technicalAdvantages/wap/bgImage4-content.png
// module id = jFYz
// module chunks = 0